<script>
  /* Routify */
  import { goto } from '@sveltech/routify'

  import { afterUpdate } from "svelte";


  /* Stores */
  import storeGlobal from "../../stores/storeGlobal";
  import store from '../../stores/storeGlobal';

  /* Variables */
  let searchTerm = $storeGlobal.searchTerm;
  let defaultFilter = {
    vegan: false,
    lightfast: false,
    singlePigment: false,
    producer: 'All',
    medium: 'All',
    staining: 'All',
    transparency: 'All',
    granulation: 'All',
    quality: 'All'
  }

  afterUpdate( () => {
    if( $storeGlobal.searchPigment) {
      searchTerm = $storeGlobal.searchTerm;
      storeGlobal.updateItem('searchPigment', false);
    }
  })

  /* Functions */
  const searchNow = () => {
    storeGlobal.updateItem('searchTerm', searchTerm);

    if($storeGlobal.searchTerm === "") {
      storeGlobal.updateItem('showItems', 10);
    } else {
      $goto('/')
    }
  }

  const clearSearch = () => {
    storeGlobal.updateItem('searchTerm', "");
    searchTerm = ""
  }

  const toggleFilter = () => {
    storeGlobal.updateItem('showFilter', !$storeGlobal.showFilter);
  }

  /* Reactivity */
  $: setFilter = JSON.stringify(defaultFilter) !== JSON.stringify($storeGlobal.searchFilter);
  $: searchT = $storeGlobal.searchTerm;
</script>

<!-- Markup -->
<div class="flex w-full items-center">

  <!-- Searchinput -->
  <div class="relative w-full">

    <!-- searchIcon -->
    <div class="absolute inset-y-0 left-0 flex items-center pl-3">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
           class="h-5 w-4 fill-current text-smoke_xd">
        <path d="M10.569 0C4.74 0 0 4.741 0 10.569c0 5.828 4.741 10.569 10.569
                 10.569 5.828 0 10.569-4.741 10.569-10.57C21.138 4.742 16.397
                 0 10.568 0zm0 19.187c-4.752 0-8.618-3.866-8.618-8.618S5.817
                 1.95 10.569 1.95s8.618 3.866 8.618 8.618-3.866 8.618-8.618 8.618z"/>
        <path d="M23.714 22.335L18.12 16.74a.975.975 0 10-1.38 1.38l5.595
                 5.593a.972.972 0 001.38 0 .975.975 0 000-1.38z"/>
      </svg>
    </div>

    <!-- Searchinput -->
    <input class="appearance-none
                  bg-snow_d
                  h-10
                  pl-10
                  pr-3
                  rounded-lg
                  w-full
                  text-base
                  text-silver
                  border
                  border-transparent
                  leading-normal
                  block
                  hover:bg-white
                  hover:border-teal
                  focus:bg-white
                  focus:border-teal
                  focus:outline-none
                  dark:bg-slate
                  dark:text-silver
                  dark-hover:bg-blackd
                  dark-focus:bg-blackd"
           type="search"
           name="q"
           placeholder="Search colors..."
           on:keyup="{ searchNow }"
           bind:value="{searchTerm}" />

    {#if searchT}
    <div class="absolute inset-y-0 right-0 flex items-center pr-4">
      <button class=" text-white p-1 rounded-full hover:bg-teal_l" on:click="{ clearSearch }">
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="fill-current w-3 h-3 text-slate dark:text-smoke_xd">
          <path d="M8.884 8l6.933-6.933a.625.625 0 10-.884-.884L8 7.116
                  1.067.183a.625.625 0 10-.884.884L7.116 8 .183 14.933a.625.625
                  0 10.884.884L8 8.884l6.933 6.933a.623.623 0 00.884 0 .625.625
                  0 000-.884z"/>
        </svg>
      </button>
    </div>
    {/if}
  </div>

  <!-- Filterbutton -->
  <button class="relative
                 flex
                 items-center
                 border
                 border-smoke
                 text-silver
                 h-10
                 px-3
                 rounded-lg
                 ml-2
                 transition-colors
                 duration-200
                 hover:bg-teal
                 hover:border-teal
                 hover:text-snow
                 focus:outline-none
                 dark:border-silver
                 dark-hover:bg-teal_d"
          class:active="{$storeGlobal.showFilter}"
          on:click="{ toggleFilter }">

    {#if setFilter}
      <div class="absolute bg-orange top-0 right-0 -mt-1 -mr-1 px-2 text-xs rounded-full text-white">
        !
      </div>
    {/if}

    <!-- Icon -->
    <svg viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current">
      <path d="M6.222 11h3.556V9.167H6.222zM0 0v1.833h16V0zm2.667 6.417h10.666V4.583H2.667z"/>
    </svg>
    <!-- Content -->
    <span class="text-base ml-2"> Filters </span>
  </button>
</div>

<style>
  .active {
    @apply bg-teal border-teal text-snow;
  }

  .filter {
    margin-top: -8px;
    margin-right: -5px;
  }
</style>
